import type { NimbusModuleOptions } from '@nimbus/types'
import { useRuntimeConfig } from '#imports'

export const useNimbusConfig = (): NimbusModuleOptions => {
    const config = useRuntimeConfig()

    return config.public.nimbus as NimbusModuleOptions
}
